import { riskManagementResourceAdapter } from './RiskManagement.resource';
export function dexArbitrageResource(data) {
    var accountBroker = {
        id: data.account.broker.id,
        name: data.account.broker.name,
        separator: data.account.broker.separator,
        hasUniqueTradeId: data.account.broker.hasUniqueTradeId
    };
    var pairBroker = {
        id: data.mainPair.broker.id,
        name: data.mainPair.broker.name,
        separator: data.mainPair.broker.separator,
        hasUniqueTradeId: data.account.broker.hasUniqueTradeId
    };
    var compareBroker = {
        id: data.compareBroker.id,
        name: data.compareBroker.name,
        separator: data.compareBroker.separator,
        hasUniqueTradeId: data.account.broker.hasUniqueTradeId
    };
    var account = {
        id: data.account.id,
        name: data.account.name,
        key: data.account.key,
        secret: data.account.secret,
        passphrase: data.account.passphrase,
        broker: accountBroker,
        pair: data.account.pair,
        main: data.account.main,
        client: data.account.client,
        type: data.account.type,
        mainAccount: data.account.mainAccount
    };
    var mainPair = {
        id: data.mainPair.id,
        name: data.mainPair.name,
        baseCurrency: data.mainPair.baseCurrency,
        quoteCurrency: data.mainPair.quoteCurrency,
        maxSum: data.mainPair.maxSum,
        broker: pairBroker,
        restartMaxTimeValue: data.mainPair.restartMaxTimeValue,
        minQuantity: data.mainPair.minQuantity
    };
    var comparePair = {
        id: data.comparePair.id,
        name: data.comparePair.name,
        baseCurrency: data.comparePair.baseCurrency,
        quoteCurrency: data.comparePair.quoteCurrency,
        maxSum: data.comparePair.maxSum,
        broker: compareBroker,
        restartMaxTimeValue: data.comparePair.restartMaxTimeValue,
        minQuantity: data.comparePair.minQuantity
    };
    var hedging = data.hedging ? {
        use: data.hedging.use,
        id: data.hedging.id,
        algorithm: data.hedging.algorithm,
        account: data.hedging.account,
        pair: data.hedging.pair,
        coverType: data.hedging.coverType,
        coverValue: data.hedging.coverValue
    } : null;
    var riskManagement = riskManagementResourceAdapter(data.riskManagement);
    return {
        id: data === null || data === void 0 ? void 0 : data.id,
        account: account,
        mainPair: mainPair,
        comparePair: comparePair,
        compareBroker: compareBroker,
        active: data.active,
        createdAt: data.createdAt,
        coefficientType: data.coefficientType,
        coefficient: data.coefficient,
        sumType: data.sumType,
        sumBid: data.sumBid,
        sumAsc: data.sumAsc,
        statuses: data.statuses,
        hedging: hedging,
        riskManagement: riskManagement
    };
}
